import React from 'react';

import cn from 'classnames';

import { Flex, Skeleton, Switcher, UiButton } from '@shared/ui';
import { useEstimateSettings } from '@widgets/EstimateInformation/lib/hooks/useEstimateSettings';
import { AddButton } from '@widgets/EstimateInformation/ui/AddButton/AddButton';
import { MultiEstimateLink } from '@widgets/EstimateInformation/ui/EstimateSettings/MultiEstimateLink';
import { SingleEstimateLink } from '@widgets/EstimateInformation/ui/EstimateSettings/SingleEstimateLink/SingleEstimateLink';
import { InfoItem } from '@widgets/EstimateInformation/ui/InfoItem';

import cls from './EstimateSettings.module.css';

interface EstimateSettingsProps {
    classes?: string;
}

export const EstimateSettings = ({ classes }: EstimateSettingsProps) => {
    const {
        t,
        onOpenCreateEstimateModal,
        onActiveSingleListSorting,
        isShowAllEstimates,
        handleToggleMoreEstimates,
        wrapperRef,
        hiddenCount,
        isShowEstimates,
        data,
        isActiveSingleListSorting,
        isPending,
        isShowWorks,
    } = useEstimateSettings();

    return (
        <Flex direction="column" align="start" gap={8} className={cn(cls.settings, classes)}>
            {isShowWorks && (
                <InfoItem
                    label={
                        data?.parentEstimate
                            ? t('EstimateSettings.return.Flex.InfoItem.label.mainEstimate')
                            : t('EstimateSettings.return.Flex.InfoItem.label.AdditionalWork')
                    }
                >
                    <div className={cls.works}>
                        {isShowEstimates && (
                            <div className={cls.estimatesWrapper} ref={wrapperRef}>
                                {data?.parentEstimate && (
                                    <SingleEstimateLink
                                        estimate={data?.parentEstimate}
                                        isShowAllEstimates={isShowAllEstimates}
                                    />
                                )}
                                {!!data?.childEstimates.length && (
                                    <MultiEstimateLink
                                        isShowAllEstimates={isShowAllEstimates}
                                        estimates={data?.childEstimates}
                                        hiddenCount={hiddenCount}
                                    />
                                )}
                            </div>
                        )}
                        {!!hiddenCount && !isShowAllEstimates && (
                            <UiButton
                                onClick={handleToggleMoreEstimates}
                                className={cls.moreButton}
                                btnText={`${t(
                                    'EstimateSettings.Flex.InfoItem.works.UiButton.btnText'
                                )} ${hiddenCount}`}
                            />
                        )}
                        {data?.canAddChildEstimate && (
                            <AddButton
                                isShowLabel={!isShowEstimates || isShowAllEstimates}
                                onClick={onOpenCreateEstimateModal}
                            />
                        )}
                    </div>
                </InfoItem>
            )}
            <InfoItem label={t('EstimateSettings.return.InfoItem.label.sort')}>
                {isPending ? (
                    <Skeleton width={36} height={20} border="8px" />
                ) : (
                    <Switcher
                        isActive={isActiveSingleListSorting}
                        onClick={onActiveSingleListSorting}
                    />
                )}
            </InfoItem>
        </Flex>
    );
};
